/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/location';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "ValidateAddressRequest": {
                "fields": {
                  "address": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ValidateAddressResponse": {
                "fields": {
                  "normalizedAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 1,
                    "rule": "optional"
                  },
                  "addressNormalizationResult": {
                    "type": "squareup.corporate_card.service.ValidateAddressResponse.AddressNormalizationResult",
                    "id": 2,
                    "rule": "optional"
                  },
                  "correctedFields": {
                    "type": "squareup.corporate_card.service.ValidateAddressResponse.CorrectedField",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "CorrectedField": {
                    "values": {
                      "DO_NOT_USE_FIELD": 0,
                      "ADDRESS_LINE_1": 1,
                      "ADDRESS_LINE_2": 2,
                      "ADMINISTRATIVE_DISTRICT_LEVEL_1": 3,
                      "LOCALITY": 4,
                      "POSTAL_CODE": 5
                    }
                  },
                  "AddressNormalizationResult": {
                    "values": {
                      "DO_NOT_USE_RESULT": 0,
                      "SUCCESS": 1,
                      "VERIFICATION_NOT_AVAILABLE": 2,
                      "VERIFICATION_FAILED": 3,
                      "UNKNOWN_ERROR": 4
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ValidateAddressRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ValidateAddressResponse && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ValidateAddressResponse?.nested?.CorrectedField && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ValidateAddressResponse?.nested?.AddressNormalizationResult) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ValidateAddressRequest @ squareup/corporate_card/service/validate_address.proto at 10:1
 */
export const ValidateAddressRequest = $root.lookupType('squareup.corporate_card.service.ValidateAddressRequest');
fixType(ValidateAddressRequest, {
  address: {
    required: true
  }
});
Builder.createAndAttachToType(ValidateAddressRequest);
/**
 * SOURCE ValidateAddressResponse @ squareup/corporate_card/service/validate_address.proto at 17:1
 */
export const ValidateAddressResponse = $root.lookupType('squareup.corporate_card.service.ValidateAddressResponse');
fixType(ValidateAddressResponse);
Builder.createAndAttachToType(ValidateAddressResponse);
/**
 * SOURCE CorrectedField @ squareup/corporate_card/service/validate_address.proto at 18:3
 */
ValidateAddressResponse.CorrectedField = $root.lookupEnum('squareup.corporate_card.service.ValidateAddressResponse.CorrectedField').values;
/**
 * SOURCE AddressNormalizationResult @ squareup/corporate_card/service/validate_address.proto at 27:3
 */
ValidateAddressResponse.AddressNormalizationResult = $root.lookupEnum('squareup.corporate_card.service.ValidateAddressResponse.AddressNormalizationResult').values;